import { render } from "./5.BecomeClientSection.vue?vue&type=template&id=ef722936&scoped=true"
import script from "./5.BecomeClientSection.vue?vue&type=script&lang=js"
export * from "./5.BecomeClientSection.vue?vue&type=script&lang=js"

import "./5.BecomeClientSection.vue?vue&type=style&index=0&id=ef722936&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef722936"]])

export default __exports__